<template>
    <div class="card border shadow dashboard-widget dashboard-widget--purchase-order dashboard-widget--purchase-order-log">
        <div class="card-header">
            <h6 class="mb-0 fw-bold dashboard-widget__title">
                <span class="dashboard-widget__icon" v-html="sidebarSvg.purchaseOrder"></span>
                <span>{{ $t('Purchase Order') }}</span>
            </h6>
        </div>
        <div class="card-body p-0">
            <div class="purchase-order-log__table-scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>{{ $t('S/N') }}</th>
                            <th>{{ $t('PO No.') }}</th>
                            <th>{{ $t('Vendor') }}</th>
                            <th>{{ $t('Description') }}</th>
                            <th>{{ $t('Last Updated') }}</th>
                            <th>{{ $t('Status')}}</th> 
                            <th class="text-end">{{ $t('Amount') }}</th>
                            <th class="dashboard-widget-table__actions">{{ $t('Actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="data.length==0">
                            <td colspan="8" class="text-center dashboard-widget__empty-state">{{ $t('No data Found') }}</td>
                        </tr>
                        <tr v-for="(item,key) in data" :key="key">
                            <td>{{ key + 1 }}</td>
                            <td> <a :href="dotNetUrl + '/purchaseorder/PurchaseOrderApproval/' + item.id" class="link-style-custom"> {{projectInfo.projectNumber}}-{{item.poNumber}}</a> </td>
                            <td>{{ item.vendorName }}</td>
                            <td>
                                <small> {{ item.description }}</small>
                            </td>
                            <td>{{ ReformatDate(item.date) }}</td>
                            <td>
                                <span class="purchase-order-status" :class="[color[item.status - 1], getStatusClass(item.statusName)]">{{item.statusName}}</span>
                            </td>
                            <td class="text-end">{{projectInfo.currencyId?.sign}}{{ ReformatNumber(item.amount) }}</td>
                            <td class="dashboard-widget-table__actions">
                                <a :href="dotNetUrl + '/purchaseorder/PurchaseOrderApproval/' + item.id" :title="$t('View')" :aria-label="$t('View')">
                                    <i class="fa-regular fa-eye" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="dashboard-widget__footer dashboard-widget__footer--end"> <a :href="dotNetUrl + '/PurchaseOrder/purchaseordersList?projectId='+projectInfo.projectOldId" class="dashboard-widget__link">{{ $t('View All') }}</a></div>
        </div>
    </div>
</template>

<script>
import {DashboardGetProjectPurchaseOrders} from '@/actions/projectActions.js'
import {ReformatNumber, ReformatDate} from '../../helpers/utilities.js'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
import 'dotenv/config'
export default {
    name : 'PurchaseOrdersList',
    props : ['projectInfo'],
    data(){
        return {
            data : [],
            dotNetUrl : process.env.VUE_APP_DOTNET_URL,
            color : ['text-muted','text-info','text-success','text-warning','text-warning','text-primary','text-success'],
            sidebarSvg
        }
    },
    mounted : async function(){
        const self = this

        const response = await DashboardGetProjectPurchaseOrders(self.projectInfo._id)
        if(!response)
            return
        self.data = response.data
    },
    methods :{
        ReformatNumber,
        ReformatDate,
        getStatusClass(statusName) {
            return `purchase-order-status--${String(statusName || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`
        }
    }
    
} 
</script>
